import React, { useState, useEffect } from 'react';
import styles from './Admin.module.css';

const UserDetail = ({ user, onClose, updateUserVerification }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [localUser, setLocalUser] = useState(user);

    // Mettre à jour l'utilisateur local lorsque les props changent
    useEffect(() => {
        setLocalUser(user);
    }, [user]);

    const handleVerification = async (isVerified) => {
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            // Mettre à jour localement avant l'appel API
            setLocalUser(prev => ({ ...prev, is_verified: isVerified }));

            await updateUserVerification(user.id, isVerified);

            const statusText = isVerified === true
                ? 'approuvé'
                : isVerified === false
                    ? 'rejeté'
                    : 'remis en attente';

            setSuccess(`L'utilisateur a été ${statusText} avec succès.`);
        } catch (error) {
            setError(`Erreur lors de la mise à jour du statut: ${error.message}`);
            // Restaurer l'état précédent en cas d'erreur
            setLocalUser(user);
        } finally {
            setLoading(false);
        }
    };

    const getStatusLabel = (status) => {
        if (status === true) return 'Vérifié';
        if (status === false) return 'Non vérifié';
        return 'En attente';
    };

    const getStatusClass = (status) => {
        if (status === true) return styles.statusVerified;
        if (status === false) return styles.statusRejected;
        return styles.statusPending;
    };

    return (
        <div className={styles.userDetailOverlay}>
            <div className={styles.userDetailModal}>
                <button className={styles.closeButton} onClick={onClose}>×</button>

                <h2 className={styles.userDetailTitle}>Détails de l'utilisateur</h2>

                {error && <div className={styles.errorMessage}>{error}</div>}
                {success && <div className={styles.successMessage}>{success}</div>}

                <div className={styles.userDetailContent}>
                    <div className={styles.userDetailHeader}>
                        <div className={styles.userDetailName}>
                            {localUser.firstname} {localUser.lastname}
                        </div>
                        <div className={`${styles.userDetailStatus} ${getStatusClass(localUser.is_verified)}`}>
                            {getStatusLabel(localUser.is_verified)}
                        </div>
                    </div>

                    <div className={styles.userDetailInfo}>
                        <div className={styles.userDetailRow}>
                            <span className={styles.userDetailLabel}>Email:</span>
                            <span className={styles.userDetailValue}>{localUser.email}</span>
                        </div>

                        <div className={styles.userDetailRow}>
                            <span className={styles.userDetailLabel}>Profession:</span>
                            <span className={styles.userDetailValue}>{localUser.profession_name || localUser.profession_id || '-'}</span>
                        </div>

                        <div className={styles.userDetailRow}>
                            <span className={styles.userDetailLabel}>Lieu de travail:</span>
                            <span className={styles.userDetailValue}>{localUser.working_place || '-'}</span>
                        </div>

                        <div className={styles.userDetailRow}>
                            <span className={styles.userDetailLabel}>Pays:</span>
                            <span className={styles.userDetailValue}>{localUser.country_name || localUser.country_id || '-'}</span>
                        </div>

                        <div className={styles.userDetailRow}>
                            <span className={styles.userDetailLabel}>Statut actuel:</span>
                            <span className={`${styles.userDetailValue} ${getStatusClass(localUser.is_verified)}`}>
                                {getStatusLabel(localUser.is_verified)}
                                {loading && <span className={styles.loadingIndicator}> (mise à jour en cours...)</span>}
                            </span>
                        </div>
                    </div>

                    <div className={styles.userDetailActions}>
                        <button
                            className={styles.verifyButton}
                            onClick={() => handleVerification(true)}
                            disabled={loading || localUser.is_verified === true}
                        >
                            Approuver l'utilisateur
                        </button>

                        <button
                            className={styles.rejectButton}
                            onClick={() => handleVerification(false)}
                            disabled={loading || localUser.is_verified === false}
                        >
                            Rejeter l'utilisateur
                        </button>

                        {localUser.is_verified !== null && (
                            <button
                                className={styles.resetButton}
                                onClick={() => handleVerification(null)}
                                disabled={loading || localUser.is_verified === null}
                            >
                                Réinitialiser le statut
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDetail; 